import { EPhotoSource } from "@/domains/site/site-photo-source.types.ts";
import { ESitePhotoOcrResultStatus } from "@/types/backoffice/dto/photo/site-photo-dto.ts";

const ocrResult: Record<ESitePhotoOcrResultStatus, string> = {
  [ESitePhotoOcrResultStatus.NOT_DONE]: "Pas prêt",
  [ESitePhotoOcrResultStatus.PENDING]: "En attente",
  [ESitePhotoOcrResultStatus.PROCESSING]: "En cours de traitement",
  [ESitePhotoOcrResultStatus.OK]: "Ok",
  [ESitePhotoOcrResultStatus.KO]: "Ko",
  [ESitePhotoOcrResultStatus.FAILED]: "Echec",
};

const source: Record<EPhotoSource, string> = {
  [EPhotoSource.UNKNOWN]: "Inconnu",
  [EPhotoSource.VOLTINSTALL_CAMERA]: "Prise en direct",
  [EPhotoSource.VOLTINSTALL_GALLERY]: "Chargée depuis la galerie",
};

const photoLocale = {
  photos: {
    upload: {
      modalTitle: "Uploader des photos",
      photoTypeRef: "Type de photo",
    },
    uploadLabel: "Upload",
    size: {
      large: "Grand",
      medium: "Moyen",
      small: "Petit",
    },
    gallery: "Galerie",
    noThumbnailType: "Pas d'aperçu, cliquez pour voir {photoName}",
    filter: {
      date: "Date",
      photoType: "Type de photo",
    },
    noPhotos: "Aucune photo",
    noPhotosDesc: "Ce site ne possède aucune photo, revenez plus tard",
    modulator: {
      label: "Identifiant de modulateur",
      columnDetail: "Colonne ID de la table CS_MODULATOR",
    },
    ocrResultStatus: "Statut du document",
    updateOcrStatusDialog: {
      title: "Modifier le statut du document",
      currentStatusLabel: "Statut actuel :",
      newStatusLabel: "Nouveau statut",
      menuEditLabel: "Modifier le statut du document",
      cancel: "Annuler",
      save: "Sauvegarder",
    },
    ocrResult: ocrResult,
    source: source,
    geolocation: {
      latitude: "Latitude",
      longitude: "Longitude",
      openstreetmap: "Openstreetmap",
    },
  },
};

export type PhotoLocale = typeof photoLocale;
export default photoLocale;
